<template>
  <FormControl :label="label" :disabled="disabled">
    <VueCtkDateTimePicker
      ref="picker"
      slot-scope="slotProps"
      v-model="value"
      format="YYYY-MM-DDTHH:mmZ"
      :dark="isDarkMode()"
      :error="slotProps.hasError"
      @input="onChange"
      :no-label="true"
      :min-date="min"
      :max-date="max"
      :id="`datepicker-${name}`"
      :disabled-hours="disabledHours"
      :disabled="disabled"
      :no-weekends-days="noWeekendsDays"
      :disabled-dates="disabledDates"
    ></VueCtkDateTimePicker>
  </FormControl>
</template>

<script>
import FormControl from "./FormControl";
import formControlMixin from "./mixins/form-control.mixin.js";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
const asyncDatePicker = import("vue-ctk-date-time-picker");

dayjs.extend(utc);

export default {
  name: "date-picker",
  props: {
    label: {
      type: String
    },
    model: {
      type: Object
    },
    name: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    min: {
      type: String
    },
    max: {
      type: String
    },
    allowWeekendDays: {
      type: Boolean,
      default: true
    },
    disabledHours: {
      type: Array,
      default: () => []
    },
    disabledDates: {
      type: Array,
      default: () => []
    },
    noWeekendsDays: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormControl,
    'VueCtkDateTimePicker': () => asyncDatePicker
  },
  data() {
    return {
      value: ""
    };
  },
  mounted() {
    this.initValue();

  },
  updated() {
    this.initValue();
  },
  mixin: [formControlMixin],
  methods: {
    initValue() {
      let val = this.getValue();

      let str = '';

      if (val instanceof Date) {
        str = dayjs(val).local().format().substring(0, '0000-00-00T00:00'.length);
      } else if (typeof(val) == 'string') {
        str = val;
      }

      this.value = str;
      this.model[this.name] = str;
    },

    getValue() {
      return this.model[this.name];
    },
    onChange(date) {
      date = date.substring(0, '0000-00-00T00:00'.length);
      this.model[this.name] = date;
      this.$emit("change", date);
    },
    isDarkMode() {
      return $("body").hasClass("dark");
    }
  },
  computed: {
    allowsWeekendDays() {
      return !this.noWeekendsDays;
    }
  }
};
</script>
